import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation PlanCreateMutation (
  $workspace: ID!,
  $data: PlanCreateInputData
) {
  planCreate (
    workspace: $workspace
    data: $data
  ) {
    id
  }
}`

async function requestPlanCreate (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('plan-create', errors)
  }
  return data.planCreate
}

export default requestPlanCreate
